import React, { useState, useEffect } from 'react';
import { Box, Button, Typography, Modal, TextField, MenuItem, Select, InputLabel, FormControl, Table, TableBody, TableCell, TableHead, TableRow, Checkbox, FormControlLabel } from '@mui/material';
import DashboardLayout from './DashboardLayout';
import axios from 'axios';
import moment from 'moment';

const FaltaPage = () => {
    const [user, setUser] = useState(null);
    const [faltas, setFaltas] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [isFullDay, setIsFullDay] = useState(false); // Novo estado para controlar a checkbox "Dia inteiro"
    const [newFalta, setNewFalta] = useState({
        dia: '',
        tipo_falta: 'injustificada',  // Definir "Injustificada" como padrão
        horario_inicio: '',
        horario_fim: '',
        documento_justificacao: null,
    });
    const apiBaseURL = 'https://plasticemployers.duckdns.org';      // IP da rede local


    useEffect(() => {
        const storedUser = localStorage.getItem('user');
        if (storedUser) {
            const parsedUser = JSON.parse(storedUser);
            setUser(parsedUser);

            if (isFullDay) {
                setHorariosPorTurno(parsedUser.turno); // Define os horários se "Dia inteiro" estiver marcado
            }
        } else {
            console.error('Usuário não encontrado no localStorage.');
        }
    }, [isFullDay]); // Reexecuta quando isFullDay muda

    useEffect(() => {
        if (user) {
            fetchFaltas();
        }
    }, [user]);

    const fetchFaltas = async () => {
        try {
            const token = localStorage.getItem('access');
            const response = await axios.get(`${apiBaseURL}/api/faltas/`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setFaltas(response.data);
        } catch (error) {
            console.error('Erro ao buscar as faltas:', error);
        }
    };

    const setHorariosPorTurno = (turno) => {
        switch (turno) {
            case 'manha-1':
                setNewFalta({ ...newFalta, horario_inicio: '05:00', horario_fim: '13:00' });
                break;
            case 'manha':
                setNewFalta({ ...newFalta, horario_inicio: '06:00', horario_fim: '14:00' });
                break;
            case 'tarde':
                setNewFalta({ ...newFalta, horario_inicio: '14:00', horario_fim: '22:00' });
                break;
            case 'noite':
                setNewFalta({ ...newFalta, horario_inicio: '22:00', horario_fim: '06:00' });
                break;
            case 'normal':
                setNewFalta({ ...newFalta, horario_inicio: '09:00', horario_fim: '18:00' });
                break;
            case 'horario_amamentacao':
                setNewFalta({ ...newFalta, horario_inicio: '10:00', horario_fim: '18:00' });
                break;
            default:
                setNewFalta({ ...newFalta, horario_inicio: '', horario_fim: '' });
                break;
        }
    };

    const handleOpenModal = () => {
        setModalOpen(true);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setNewFalta({
            ...newFalta,
            [name]: value,
        });
    };

    const handleFileChange = async (e, faltaId) => {
        const file = e.target.files[0];
        if (file) {
            const falta = faltas.find(f => f.id === faltaId);
            if (!falta) {
                alert('Falta não encontrada');
                return;
            }
    
            const formData = new FormData();
            formData.append('documento_justificacao', file);
            formData.append('tipo_falta', 'em aprovacao'); // Muda para 'em_aprovacao' ao anexar um documento
            formData.append('empregado', falta.empregado);
            formData.append('dia', falta.dia);
            formData.append('horario_inicio', falta.horario_inicio);
            formData.append('horario_fim', falta.horario_fim);
    
            const token = localStorage.getItem('access');
            try {
                await axios.put(`${apiBaseURL}/api/faltas/${faltaId}/`, formData, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data',
                    },
                });
    
                // Enviando a notificação
                const notificationMessage = `O ${user.nome_completo} acabou de fazer o upload de uma justificação de faltas para o dia ${moment(falta.dia).format('DD/MM/YYYY')}.`;
                await axios.post(`${apiBaseURL}/api/notifications/`, {
                    message: notificationMessage,
                    recipients: null, // Enviar para todos os Admins e Escritório
                }, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
    
                alert('Documento anexado com sucesso e falta em aprovação!');
                fetchFaltas(); // Atualizar a lista de faltas
            } catch (error) {
                console.error('Erro ao anexar o documento:', error.response ? error.response.data : error.message);
                alert('Erro ao anexar o documento. Por favor, tente novamente.');
            }
        }
    };
    
    

    const handleSaveFalta = async () => {
        try {
            const token = localStorage.getItem('access');
            const formData = new FormData();
            
            formData.append('empregado', user.id);
            formData.append('dia', newFalta.dia);
            formData.append('tipo_falta', newFalta.documento_justificacao ? 'em_aprovacao' : 'injustificada');
            formData.append('horario_inicio', newFalta.horario_inicio);
            formData.append('horario_fim', newFalta.horario_fim);
            if (newFalta.documento_justificacao) {
                formData.append('documento_justificacao', newFalta.documento_justificacao);
            }
    
            let response;
            if (newFalta.id) {
                // Atualizando uma falta existente
                response = await axios.put(`${apiBaseURL}/api/faltas/${newFalta.id}/`, formData, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data',
                    },
                });
            } else {
                // Criando uma nova falta
                response = await axios.post(`${apiBaseURL}/api/faltas/`, formData, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data',
                    },
                });
            }
    
            // Enviando a notificação
            const notificationMessage = `O ${user.nome_completo} acabou de notificar que terá de faltar no dia ${moment(newFalta.dia).format('DD/MM/YYYY')} das ${newFalta.horario_inicio} às ${newFalta.horario_fim}.`;
            await axios.post(`${apiBaseURL}/api/notifications/`, {
                message: notificationMessage,
                recipients: null, // Enviar para todos os Admins e Escritório
            }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
    
            alert('Falta salva com sucesso!');
            fetchFaltas(); // Atualizar a lista de faltas
            handleCloseModal();
        } catch (error) {
            if (error.response) {
                console.error('Erro ao salvar a falta:', error.response.data);
                alert(`Erro ao salvar a falta: ${JSON.stringify(error.response.data)}`);
            } else {
                console.error('Erro ao salvar a falta:', error.message);
                alert(`Erro ao salvar a falta: ${error.message}`);
            }
        }
    };
    

    if (!user) {
        return (
            <DashboardLayout>
                <Typography variant="h4" gutterBottom>
                    Erro: Usuário não encontrado
                </Typography>
                <Typography variant="body1">
                    Faça login novamente para acessar essa funcionalidade.
                </Typography>
            </DashboardLayout>
        );
    }

    return (
        <DashboardLayout>
            <Typography variant="h4" gutterBottom>
                Faltas
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: 2 }}>
                <Button variant="contained" color="primary" onClick={handleOpenModal}>
                    Adicionar uma falta
                </Button>
            </Box>
            {faltas.length === 0 ? (
                <Box sx={{ textAlign: 'center', marginTop: 4 }}>
                    <Typography variant="h6" gutterBottom>
                        Ainda não existem faltas registradas.
                    </Typography>
                    <Button variant="contained" color="primary" onClick={handleOpenModal}>
                        Criar nova falta
                    </Button>
                </Box>
            ) : (
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Dia</TableCell>
                            <TableCell>Tipo de Falta</TableCell>
                            <TableCell>Horário de Início</TableCell>
                            <TableCell>Horário de Fim</TableCell>
                            <TableCell>Documento de Justificação</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
    {faltas.map((falta) => (
        <TableRow key={falta.id}>
            <TableCell>{moment(falta.dia).format('DD/MM/YYYY')}</TableCell>
            <TableCell>{falta.tipo_falta}</TableCell>
            <TableCell>{falta.horario_inicio}</TableCell>
            <TableCell>{falta.horario_fim}</TableCell>
            <TableCell>
                {falta.documento_justificacao ? (
                    <a href={falta.documento_justificacao} target="_blank" rel="noopener noreferrer">Ver Documento</a>
                ) : (
                    <Button
                        variant="contained"
                        component="label"
                        color="primary"
                        fullWidth
                        sx={{ mt: 2 }}
                    >
                        Anexar Documento de Justificação
                        <input
                            type="file"
                            hidden
                            onChange={(e) => handleFileChange(e, falta.id)}
                        />
                    </Button>
                )}
            </TableCell>
        </TableRow>
    ))}
</TableBody>
                </Table>
            )}

            <Modal open={modalOpen} onClose={handleCloseModal}>
                <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 400, bgcolor: 'background.paper', boxShadow: 24, p: 4 }}>
                    <Typography id="modal-title" variant="h6" component="h2">
                        Adicionar Falta
                    </Typography>
                    <TextField
                        label="Empregado"
                        fullWidth
                        margin="normal"
                        value={user.nome_completo}
                        disabled
                    />
                    <TextField
                        label="Dia"
                        type="date"
                        name="dia"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                        value={newFalta.dia}
                        onChange={handleChange}
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={isFullDay}
                                onChange={(e) => setIsFullDay(e.target.checked)}
                                color="primary"
                            />
                        }
                        label="Dia inteiro"
                    />
                    <TextField
                        label="Horário de Início"
                        type="time"
                        name="horario_inicio"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                        value={newFalta.horario_inicio}
                        disabled={isFullDay} // Desativa se "Dia inteiro" estiver marcado
                        onChange={handleChange}
                    />
                    <TextField
                        label="Horário de Fim"
                        type="time"
                        name="horario_fim"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                        value={newFalta.horario_fim}
                        disabled={isFullDay} // Desativa se "Dia inteiro" estiver marcado
                        onChange={handleChange}
                    />
                    <Button
                        variant="contained"
                        component="label"
                        color="primary"
                        fullWidth
                        sx={{ mt: 2 }}
                    >
                        Anexar Documento de Justificação
                        <input
                            type="file"
                            hidden
                            onChange={(e) => setNewFalta({...newFalta, documento_justificacao: e.target.files[0]})}
                        />
                    </Button>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: 2 }}>
                        <Button onClick={handleCloseModal} variant="contained" color="secondary">
                            Cancelar
                        </Button>
                        <Button onClick={handleSaveFalta} variant="contained" color="primary">
                            Salvar Falta
                        </Button>
                    </Box>
                </Box>
            </Modal>
        </DashboardLayout>
    );
};

export default FaltaPage;
